module.exports = __webpack_public_path__ + "ax.no2.e92386fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ax.no2.jpg
// module id = IjuI
// module chunks = 0